module.exports = __webpack_public_path__ + "img/loading-small@2x.14e5ac73.png";